import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "aap_cookie_consent_v1";

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) setVisible(true);
        } catch { /* ignore */ }
    }, []);

    const record = (value) => {
        try { localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() })); } catch { /* ignore */ }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-consent"
            className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 card-flat p-5 shadow-xl bg-zinc-950/95 backdrop-blur-xl border-zinc-700 animate-fade-up"
        >
            <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-sm bg-zinc-900 border border-zinc-800 flex items-center justify-center flex-shrink-0">
                    <Cookie className="h-4 w-4 text-yellow-400" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="font-display text-sm font-semibold text-white">We use cookies</div>
                    <p className="text-xs text-zinc-400 mt-2 leading-relaxed">
                        We use essential cookies for site functionality and analytics cookies to understand how visitors
                        use All About Printers. See our{" "}
                        <Link to="/privacy" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">privacy policy</Link>.
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <button
                            onClick={() => record("accepted")}
                            data-testid="cookie-accept"
                            className="btn-primary text-xs px-4 py-2"
                        >
                            Accept all
                        </button>
                        <button
                            onClick={() => record("essential")}
                            data-testid="cookie-essential"
                            className="btn-ghost text-xs px-4 py-2"
                        >
                            Essential only
                        </button>
                    </div>
                </div>
                <button
                    onClick={() => record("dismissed")}
                    data-testid="cookie-dismiss"
                    aria-label="Dismiss"
                    className="h-7 w-7 rounded-sm text-zinc-500 hover:text-white hover:bg-zinc-900 flex items-center justify-center transition-colors flex-shrink-0"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
